import { createFileRoute } from "@tanstack/react-router";
import { productsQuery } from "@/api/queries/products";
import { GameTypesPage } from "@/pages/marketplace/GameTypesPage";

// The trailing `_` keeps this out of `/marketplace`'s route, so the page does not
// inherit the catalog's search schema — it has no filters of its own.
export const Route = createFileRoute("/_app/marketplace_/gametypes")({
  loader: ({ context }) => context.queryClient.ensureQueryData(productsQuery({ pageSize: 1 })),
  component: GameTypesPage,
});
